'use client';

import Button from '../button';
import { TitleWrapper } from './title-wrapper';

export type StepperFormSuccessProps = {
	title: string;
	titleHTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
	asHtmlString?: boolean;
	description: string;
	ctaLabel: string;
	onCtaClick: () => void;
};

export const StepperFormSuccess = ({
	title,
	asHtmlString = false,
	titleHTag = 'h2',
	description,
	ctaLabel,
	onCtaClick,
}: StepperFormSuccessProps) => {
	return (
		<div className="flex w-full flex-col items-center justify-center text-center spacing-stack-l py-[60px]">
			<TitleWrapper
				asHtmlString={asHtmlString}
				title={title}
				titleHTag={titleHTag}
				className="text-h4 text-text-heading"
			/>
			<p
				className="text-body3 text-text-primary max-w-[540px] [&_a]:text-text-primary [&_a]:underline [&_a]:decoration-solid [&_a]:text-text-primary [&_a]:decoration-1 [&_a]:underline-offset-3 [&_a]:[text-decoration-skip-ink:none]"
				dangerouslySetInnerHTML={{ __html: description }}
			/>
			<Button type="button" intent="filled" onClick={onCtaClick}>
				{ctaLabel}
			</Button>
		</div>
	);
};
